import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { RecruiterRoutingModule } from './recruiter-routing.module';
import { RecruiterListComponent } from './recruiter-list/recruiter-list.component';
import { RecruiterCreateComponent } from './recruiter-create/recruiter-create.component';

@NgModule({
  declarations: [RecruiterListComponent, RecruiterCreateComponent],
  imports: [
    CommonModule,
    RecruiterRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class RecruiterModule { }
